import {ReactElement} from "react";

export const StarItem: React.FC<{ size: number, color: string, starPath: ReactElement}> = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={props.size}
			height={props.size}
			fill="currentColor"
			className="bi bi-star-half"
			viewBox="0 0 16 16"
			style={{color: `${props.color}`}}
		>
			{props.starPath}
		</svg>
	);
};
